import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { AiChatFormComponent } from './ai-chat-form.component';

@Injectable()
export class AiChatFormDialog {
  #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(AiChatFormComponent);
  }
}
